import './index.scss';
import { useCallback, useContext } from 'react';
import { AppLabel, FlexRow } from 'src/style';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';

export const ResultTable = () => {
    const { info } = useContext(AppInfoContext);

    const renderResult = useCallback((resultList) => resultList?.map((result: any, i: number) => (
        <FlexRow className='result-items' key={i} justifyContent='space-between' isMaxWidth>
            <AppLabel className='result-sn' fontWeight='500' color='#374957' align='center'>{i + 1}</AppLabel>
            <AppLabel className='subject' fontWeight='500' color='#374957' align='center'>{result?.subject}</AppLabel>
            <AppLabel className='test-score' fontWeight='500' color='#374957' align='center'>{result?.testScore}</AppLabel>
            <AppLabel className='exam-score' fontWeight='500' color='#374957' align='center'>{result?.examScore}</AppLabel>
            <AppLabel className='total-score' fontWeight='500' color='#374957' align='center'>{result?.totalScore}</AppLabel>
        </FlexRow>
    )), [])

    return (
        <div className="result-table">
            <FlexRow className='title-items' justifyContent='space-between' isMaxWidth>
                <AppLabel className='result-sn' fontWeight='600' color='#712126' align='center'>SN</AppLabel>
                <AppLabel className='subject' fontWeight='600' color='#712126' align='center'>Subject</AppLabel>
                <AppLabel className='test-score' fontWeight='600' color='#712126' align='center'>Test Score</AppLabel>
                <AppLabel className='exam-score' fontWeight='600' color='#712126' align='center'>Exam Score</AppLabel>
                <AppLabel className='total-score' fontWeight='600' color='#712126' align='center'>Total Score</AppLabel>
            </FlexRow>
            {renderResult(info?.result?.result)}
        </div>
    )
}
